import { Box, Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getJsonResult } from "../../services/FetchServices";

const LoginInPage: React.FC = () => {
  const [downTimeMessage, setDownTimeMessage] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const errorParams = params.get("error") || "";
    setError(errorParams);
  }, [location]);

  useEffect(() => {
    var url = `${process.env.REACT_APP_BACKEND_URL}/login/getMessage`;
    getJsonResult(url)
      .then((response) => response.json())
      .then((data: any) => {
        setDownTimeMessage(data[0]);
      });
  }, []);

  return (
    <>
      <div className="body-login">
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: "auto",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Button
            id="matmLoginButton"
            variant="contained"
            color="primary"
            href="/oauth2/authorization/manh"
            style={{
              width: 300,
              marginBottom: "10px",
            }}
          >
            Log in
          </Button>
          <div id="loginButtonMessage" style={{ padding: "10px" }}>
            Please click Log In above for Dollar Tree’s Custom Vendor Portal
            (CVP) through Manhattan Active Supply Chain
          </div>
          {downTimeMessage && (
            <label
              id="loginDownTimeMessage"
              style={{ color: "red", textAlign: "center", fontSize: "25px" }}
            >
              Note : {downTimeMessage}
            </label>
          )}
          {error ? (
            <label
              id="loginErrorMessage"
              style={{ color: "red", textAlign: "center", fontSize: "25px" }}
            >
              {error}
            </label>
          ) : (
            <></>
          )}
        </Box>
      </div>
    </>
  );
};

export default LoginInPage;
